interface ChevronRightProps {
  color?: string;
  className?: string;
}

export const ChevronRight = ({
  color = '#4996FC',
  className = '',
}: ChevronRightProps): JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M9.29056 17.2874C8.90217 16.8962 8.90329 16.2646 9.29306 15.8749L13.1681 11.9999L9.2919 8.11526C8.90305 7.72557 8.90339 7.09454 9.29267 6.70527C9.68224 6.31569 10.3139 6.31569 10.7034 6.70527L15.2909 11.2928C15.6815 11.6833 15.6815 12.3165 15.2909 12.707L10.7081 17.2899C10.3163 17.6816 9.68089 17.6805 9.29056 17.2874Z"
      fill={color}
    />
  </svg>
);
